/* eslint-disable react/style-prop-object */
import React from 'react';

const IconLoadingError = ({ iconWidth, iconHeight }) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_777_3580)">
      <rect x="8.25586" y="14" width="35.3443" height="32.2863" rx="4" transform="rotate(4.00827 8.25586 14)" fill="#F1F3F6" />
      <path d="M28 22H16M20 30H16M32 14H16M40 24V13.6C40 10.2397 40 8.55952 39.346 7.27606C38.7708 6.14708 37.853 5.2292 36.724 4.65396C35.4404 4 33.7604 4 30.4 4H17.6C14.2397 4 12.5595 4 11.2761 4.65396C10.1471 5.2292 9.2292 6.14708 8.65396 7.27606C8 8.55952 8 10.2397 8 13.6V34.4C8 37.7604 8 39.4404 8.65396 40.724C9.2292 41.853 10.1471 42.7708 11.2761 43.346C12.5595 44 14.2397 44 17.6 44H24M32 32L42 42M42 32L32 42" stroke="#959EA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_777_3580">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>


);

export default IconLoadingError;
